import styled, { keyframes } from "styled-components";

import {
  FaArrowLeft,
  FaRegEdit,
  FaRegTrashAlt,
  FaRecycle,
  FaSync,
} from "react-icons/fa";
import { FaRegFrown } from "react-icons/fa";
import Select from "../../../components/Select";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Content = styled.div`
  width: 80%;
  height: fit-content;
  margin: 40px 10px;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;

  background-color: #eee;
  box-shadow: 2px 2px 5px;
  padding: 30px;
  border-radius: 10px;

  overflow: hidden;

  animation: ${fadeIn} 0.4s;

  > header {
    width: 100%;
    align-self: flex-start;
    display: flex;
    align-items: baseline;
    margin-bottom: 20px;
    position: relative;

    padding-right: 30px;

    > h1 {
      overflow: hidden;
      margin-left: 20px;
      font-size: 25px;
      @media (max-width: 720px) {
        font-size: 18px;
      }
    }
    > h2 {
      flex: 1;
      white-space: nowrap;
      color: var(--gray);
      margin-left: 20px;
      font-size: 18px;
    }
  }

  @media (max-width: 720px) {
    width: 90%;
    margin: 40px 10px;
  }
`;

export const IconEdit = styled(FaRegEdit)`
  cursor: pointer;
  transition: 0.3s;

  :hover {
    opacity: 0.8;
  }
  :active {
    opacity: 0.4;
  }
`;

export const IconReopen = styled(FaSync)`
  cursor: pointer;
  transition: 0.3s;

  :hover {
    color: var(--primary);
    opacity: 0.8;
  }
  :active {
    opacity: 0.4;
  }
`;

export const IconDelete = styled(FaRegTrashAlt)`
  cursor: pointer;
  transition: 0.3s;
  :hover {
    opacity: 0.8;
    color: var(--primary);
  }
  :active {
    opacity: 0.4;
  }
`;

export const Actions = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  gap: 10px;

  @media (max-width: 425px) {
    display: flex;
    flex-direction: column;
  }
`;

export const IconArrowLeft = styled(FaArrowLeft)`
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
  :active {
    opacity: 0.4;
  }
`;

export const FormVaga = styled.form`
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px;

  > div {
    > label {
      font-weight: bold;
    }

    > p {
      color: var(--gray);
      font-size: 18px;
      margin-top: 2px;

      @media (max-width: 425px) {
        font-size: 18px;
      }
    }
  }

  @media (max-width: 425px) {
    display: flex;
    flex-direction: column;
  }
`;

export const SelectTipo = styled(Select)`
  grid-column: 1/3;
`;

export const Linha = styled.div`
  grid-column: 1/3;

  display: flex;
  flex-direction: column;

  > label {
    margin-bottom: 2px;
    font-weight: bold;
  }

  > p {
    color: var(--gray);
    font-size: 25px;
    margin-bottom: 10px;

    @media (max-width: 425px) {
      font-size: 18px;
    }
  }
`;

export const ContainerRequisitos = styled.section`
  display: flex;
  flex-wrap: wrap;
`;
export const StyledTag = styled.article`
  padding: 5px 10px;
  display: flex;
  align-items: center;

  border-radius: 15px;
  background-color: var(--primary);
  color: var(--white);

  margin: 0px 10px 10px 0px;

  > span {
    margin-left: 10px;
    cursor: pointer;
    font-size: 20px;

    :hover {
      opacity: 0.8;
    }
    :active {
      opacity: 0.4;
    }
  }
`;

export const Button = styled.button`
  background-color: var(--${(props) => props.color || "primary"});
`;

export const Link = styled.button`
  background-color: transparent;
  color: var(--black);

  :hover {
    background-color: var(--primary);
    color: var(--white);
  }
`;

export const FundoAlunos = styled.div`
  width: 100%;
  height: fit-content;
  left: 0;

  /* margin-top: 10px;
  margin-bottom: 20px; */

  margin: 10px 2px 20px 2px;

  box-shadow: 2px 2px 5px;
  border: 1px solid var(--gray);

  background-color: var(--white);
  border-radius: 20px;

  @media (max-width: 425px) {
    width: calc(100% + 40px);
  }
`;

export const ContainerAlunos = styled.section`
  position: relative;
  z-index: 9;

  padding: 32px;

  > header {
    > h1 {
      font-size: 20px;
      text-align: center;
      > em {
        font-style: normal;
        font-size: 30px;

        color: var(--green);
      }
    }
  }

  > span {
    display: block;
    font-weight: bold;
    margin-bottom: 2px;
  }
`;

export const ContainerCandidatos = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 15px;
`;

export const CardCandidato = styled.div`
  width: auto;
  padding: 20px;

  border-radius: 5px;

  box-shadow: 1px 1px 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > span {
    display: block;
    margin-top: 2px;
    color: var(--gray);
  }

  > label {
    font-weight: bold;
    display: block;
    margin-top: 10px;
  }
`;

export const ContainerActions = styled.section`
  display: flex;

  justify-content: space-between;
  align-items: center;
`;

export const ButtonLink = styled.button`
  width: unset;
  padding: unset;
  text-align: left;

  display: flex;
  align-items: center;

  margin-top: 10px;

  text-decoration: underline;

  color: var(--${(props) => props.color || "primary"});
  background-color: unset;
  border: unset;

  font-size: 16px;

  > svg {
    margin-right: 4px;
  }

  :active {
    border: none;
    opacity: 0.4;
  }

  :hover {
    color: var(--black);
  }

  @media (max-width: 1080px) {
    font-size: 14px;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  z-index: 19;
  padding-top: 10px;

  overflow: hidden;

  background-color: var(--overlay);
  transition: opacity 0.4s;

  display: none;
  opacity: 0;
  align-items: center;
  justify-content: center;
`;

export const ModalContatos = styled.div`
  width: 50%;
  padding: 30px;
  position: relative;
  z-index: 999;

  max-height: 80%;
  overflow-y: auto;

  border-radius: 10px;
  background-color: var(--white);

  position: relative;

  > span {
    position: absolute;
    top: 0;
    right: 0;
    margin: 20px;

    font-size: 20px;

    transition: 0.2s;

    :hover {
      color: red;
      cursor: pointer;
    }

    :active {
      opacity: 0.4;
    }
  }

  @media (max-width: 768px) {
    width: 80%;
  }

  > section[id="contatos"] {
    > label {
      margin-bottom: 5px;
    }

    div {
      display: flex;
      flex-direction: column;
      height: center;
      margin-top: 5px;
    }

    em {
      font-size: 13px;
      margin-left: 5px;
      color: var(--darkGreen);

      :hover {
        cursor: pointer;
        opacity: 0.8;
      }

      :active {
        opacity: 0.4;
      }
    }
  }

  > section[id="pessoais"] {
    flex-direction: row;

    margin-top: 0px;

    > img {
      width: 100px;
      height: 100px;
      border-radius: 50px;
    }

    > div {
      > span {
        display: flex;
        flex-direction: row;
        margin-top: 2px;
        color: var(--gray);
      }

      > p {
        color: var(--blue);
        font-size: 14px;
      }
    }
  }

  > section[id="curriculo"] {
    > p {
      margin-top: 5px;
    }

    > a {
      margin-top: 5px;

      color: var(--gray);
      text-decoration: none;

      font-size: 18px;

      :hover {
        opacity: 0.8;
      }

      :active {
        opacity: 0.4;
      }
    }
  }

  > section {
    display: flex;
    flex-direction: column;
    height: center;

    margin-top: 20px;
    margin-bottom: 5px;

    > span {
      display: flex;
      flex-direction: row;
      margin-top: 2px;
      color: var(--gray);
    }

    > span[id="contato"] {
      color: var(--black);

      margin-top: 10px;

      display: flex;
      align-items: center;

      > svg {
        margin-right: 5px;
      }

      > a {
        text-decoration: none;
        color: var(--black);

        :hover {
          opacity: 0.8;
        }

        :active {
          opacity: 0.8;
        }
      }
    }

    > label {
      font-weight: bold;
      display: flex;
      align-items: center;

      margin-top: 10px;
      font-size: 20px;

      > svg {
        margin-right: 5px;
      }
    }

    > ul {
      margin: 0;
      padding: 0;
      > li {
        list-style: none;
        margin: 4px 0px;

        ::before {
          font-weight: bold;
          content: "-";
          margin-right: 5px;
        }
      }
    }
  }
`;

export const ModalEncerrar = styled.div`
  width: 40%;
  padding: 30px;
  padding-top: 40px;
  position: relative;
  z-index: 999;

  max-height: 80%;
  overflow-y: auto;

  border-radius: 10px;
  background-color: var(--white);

  position: relative;

  text-align: center;

  > p {
    margin-top: 10px;
    font-weight: bold;
    margin-bottom: 5px;
  }

  > h3 {
    margin: 10px 0px;
  }

  > button {
    width: 50%;
  }

  > span {
    position: absolute;
    top: 0;
    right: 0;
    margin: 20px;

    font-size: 20px;

    transition: 0.2s;

    :hover {
      color: red;
      cursor: pointer;
    }

    :active {
      opacity: 0.4;
    }
  }

  @media (max-width: 768px) {
    width: 80%;
  }
`;

export const ModalContratei = styled.div`
  width: 30%;
  padding: 30px;
  position: relative;
  z-index: 999;

  max-height: 80%;
  overflow-y: auto;

  border-radius: 10px;
  background-color: var(--white);

  position: relative;

  > h3 {
    text-align: center;
    margin-bottom: 10px;
  }

  > button {
    width: 50%;
  }

  > span {
    position: absolute;
    top: 0;
    right: 0;
    margin: 20px;

    font-size: 20px;

    transition: 0.2s;

    :hover {
      color: red;
      cursor: pointer;
    }

    :active {
      opacity: 0.4;
    }
  }

  @media (max-width: 768px) {
    width: 80%;
  }
`;

export const ImageProfileContainer = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50px;

  overflow: hidden;

  margin-right: 10px;

  > img {
    width: 60px;
    height: 60px;
  }
`;
